export default __webpack_public_path__ + "static/media/20250524-AZ400.92df9a00.pdf";